
class ThousandSeparator {
    formatWithSeparator(value) {
        if(value == "" || value == "-") return value;
        if(parseFloat(value) >= 600) 
            return parseFloat(value).toLocaleString('pt-BR',{ maximumFractionDigits: 0 }).replaceAll(",",".");
        else 
            parseFloat(value).toLocaleString('pt-BR',{ minimumFractionDigits: 1 }).replaceAll(",",".");
        return value;
    } 
}
const thousandSeparator = new ThousandSeparator();
export default thousandSeparator;
